import { render, staticRenderFns } from "./d2-container-full.vue?vue&type=template&id=77717fc0&"
import script from "./d2-container-full.vue?vue&type=script&lang=js&"
export * from "./d2-container-full.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports